import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const reelUrl =
  "https://static.metricool.com/video-converter/5517044/202609/5815579c1d7246d5.mp4";

const GameAudioReel = ({ onCreditsPage = false }) => (
  <section id="game-audio-reel" className="py-12 md:py-20 bg-[#171717] text-white">
    <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-7">
        <div>
          <span className="text-xs uppercase tracking-[0.22em] text-amber-300">
            Game &amp; VR · 60 seconds
          </span>
          <h2
            className="mt-3 text-3xl md:text-5xl font-semibold tracking-tight"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            Game Audio Reel
          </h2>
          <p className="mt-3 max-w-2xl text-white/70 leading-relaxed">
            A selection of composition, sound design, and voice work across games and VR.
          </p>
        </div>
        {!onCreditsPage && (
          <Link
            to="/work/game-credits"
            className="inline-flex items-center gap-2 self-start text-white border-b border-white/60 pb-1 hover:border-white"
          >
            Explore game credits <ArrowUpRight className="w-4 h-4" />
          </Link>
        )}
      </div>
      <div className="aspect-video w-full overflow-hidden rounded-xl bg-black shadow-2xl">
        <video
          className="w-full h-full"
          controls
          playsInline
          preload="metadata"
          poster="/images/game-audio-reel-poster.jpg"
          aria-label="Leonard R.R. Cox game audio director reel"
        >
          <source src={reelUrl} type="video/mp4" />
          Your browser does not support video playback.
        </video>
      </div>
    </div>
  </section>
);

export default GameAudioReel;
